import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';

import {login, getSession} from '../../lib/auth-api';
import {setSession} from '../../reducers/session';

import styles from './login-form.css';

class LoginForm extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            username: '',
            password: '',
            loading: false,
            error: null
        };
    }

    componentDidMount () {
        window.addEventListener('message', this.handleAuthMessage);
    }

    componentWillUnmount () {
        window.removeEventListener('message', this.handleAuthMessage);
    }

    handleAuthMessage = async event => {
        if (event.origin !== window.location.origin) return;
        if (!event.data || event.data.type !== 'SCRATCH_AUTH_SUCCESS') return;

        const data = await getSession();
        this.props.onSetSession(data.session);

        if (this.props.onClose) {
            this.props.onClose();
        }
    };

    handleSubmit = async event => {
        event.preventDefault();

        this.setState({
            loading: true,
            error: null
        });

        try {
            await login({
                username: this.state.username,
                password: this.state.password
            });

            const data = await getSession();
            this.props.onSetSession(data.session);

            if (this.props.onClose) {
                this.props.onClose();
            }
        } catch (err) {
            this.setState({
                error: 'Sai tài khoản hoặc mật khẩu'
            });
        } finally {
            this.setState({
                loading: false
            });
        }
    };

    handleGoogleLogin = () => {
        const width = 520;
        const height = 680;
        const left = window.screenX + ((window.outerWidth - width) / 2);
        const top = window.screenY + ((window.outerHeight - height) / 2);

        window.open(
            '/api/auth/google/start',
            'scratch-google-login',
            `width=${width},height=${height},left=${left},top=${top}`
        );
    };

    render () {
        return (
            <div className={styles.loginWrapper}>
                <form
                    className={styles.form}
                    noValidate
                    onSubmit={this.handleSubmit}
                >
                    <label
                        className={styles.fieldLabel}
                        htmlFor="username"
                    >
                        Username
                    </label>

                    <div className={styles.formGroup}>
                        <div className={styles.inputColumn}>
                            <input
                                className={styles.input}
                                id="username"
                                maxLength="30"
                                name="username"
                                required
                                type="text"
                                value={this.state.username}
                                onChange={event => this.setState({username: event.target.value})}
                            />
                        </div>
                    </div>

                    <label
                        className={styles.fieldLabel}
                        htmlFor="password"
                    >
                        Password
                    </label>

                    <div className={styles.formGroup}>
                        <div className={styles.inputColumn}>
                            <input
                                className={styles.input}
                                id="password"
                                name="password"
                                required
                                type="password"
                                value={this.state.password}
                                onChange={event => this.setState({password: event.target.value})}
                            />
                        </div>
                    </div>

                    {this.state.error && (
                        <div className={styles.errorMessage}>
                            {this.state.error}
                        </div>
                    )}

                    <div className={styles.submitRow}>
                        <button
                            className={styles.submitButton}
                            disabled={this.state.loading}
                            type="submit"
                        >
                            {this.state.loading ? 'Signing in...' : 'Sign in'}
                        </button>

                        <a
                            className={styles.helpLink}
                            href="/accounts/password_reset/"
                        >
                            Need Help?
                        </a>
                    </div>

                    <div className={styles.divider}>
                        <span>hoặc</span>
                    </div>

                    <button
                        className={styles.googleButton}
                        type="button"
                        onClick={this.handleGoogleLogin}
                    >
                        Login with Google
                    </button>
                </form>
            </div>
        );
    }
}

LoginForm.propTypes = {
    onClose: PropTypes.func,
    onSetSession: PropTypes.func.isRequired
};

const mapDispatchToProps = dispatch => ({
    onSetSession: session => dispatch(setSession(session))
});

export default connect(
    null,
    mapDispatchToProps
)(LoginForm);